
import moment from "moment-timezone";
import {
    visitor_payments_booking_statuses_filter,
    visitor_payments_date_filter,
    visitor_payments_payment_statuses_filter
} from "../../../../utils/mockup";
import formatters from '@/mixins/formatters.js';
import Show from "./show.vue";

export default {
    name: "index",
    components: { Show },
    data() {
        return {
            data: {
                data: [{
                    charge: {
                        amount: 12500,
                    },
                    checkin_date: "2025-06-01T14:00:00Z",
                    checkout_date: "2025-06-03T10:00:00Z",
                    payment_metadata: {
                        date: "2025-06-01T13:45:00Z"
                    },
                    pms_reservation_no: "RES123456",
                    booking_status: {
                        code: "confirmed"
                    },
                    payment_status: {
                        code: "paid"
                    },
                    captured_created_at: "2025-06-01T14:05:00Z",
                    payment_transaction_id: 789456,
                },
                {
                    charge: {
                        amount: 9800,
                    },
                    checkin_date: "2025-05-25T15:00:00Z",
                    checkout_date: "2025-05-28T11:00:00Z",
                    payment_metadata: {
                        date: "2025-05-25T14:30:00Z"
                    },
                    pms_reservation_no: "RES654321",
                    booking_status: {
                        code: "cancelled"
                    },
                    payment_status: {
                        code: "unpaid"
                    },
                    captured_created_at: null,
                    payment_transaction_id: 123789,
                }],
                current_page: 1,
                total: 0,
            },
            filter: {
                // date_to: null,
                // date_from: null,
                date_to: "05-21-2021",
                date_from: "05-21-2021",
                per_page: 50,
                page: 1,
                timezone: moment.tz.guess(),
            },
            facility: window._app_facility,
            date_filter: visitor_payments_date_filter,
            payment_statuses: visitor_payments_payment_statuses_filter,
            booking_statuses: visitor_payments_booking_statuses_filter,
            config: {
                is_date_option_selected: false,
                is_status_option_selected: false,
                clear: false,
            },
            custom_filter: {
                payment_statuses: {},
                payment_statuses_values: [],
                booking_statuses: {},
                booking_statuses_values: [],
                deduct_number_of_days: 7,
                selected_date_option_key: 0,
                // date_from: null,
                // date_to: null,
                date_to: "05-21-2021",
                date_from: "05-21-2021",
            },
        }
    },
    methods: {
        async clear_filter() {
            this.config = {
                is_date_option_selected: false,
                is_status_option_selected: false,
                clear: false,
            };
            this.custom_filter = {
                payment_statuses: {},
                payment_statuses_values: [],
                booking_statuses: {},
                booking_statuses_values: [],
                deduct_number_of_days: 7,
                selected_date_option_key: 0,
            };
            this.filter = {
                date_to: null,
                date_from: null,
                per_page: 50,
                page: 1,
                facility_id: this.facility.id,
                timezone: moment.tz.guess(),
            };

            await this.store_filter();
            await this.list({ ...this.filter, page: 1 });
        },
        async download() {
            // await this.$lionheart.get("facility-booking/list/payments", { params: { ...this.filter, download: 1 }, responseType: "arraybuffer" }).then((success) => {
            //     let data = success.data;
            //     const file = moment().format("YYYYMMDD");
            //     let blob = new Blob([data], { type: "application/xls" });
            //     const downloadUrl = window.URL.createObjectURL(blob);
            //     const link = document.createElement("a");
            //     link.href = downloadUrl;
            //     link.setAttribute("download", `${file}_payments.xlsx`); //any other extension
            //     document.body.appendChild(link);
            //     link.click();
            //     link.remove();
            // });
            return true
        },
        async paginate(page) {
            // await this.list({ ...this.filter, page: page });
        },


        async view(payment_id, facility_id) {
            // let data = await this.$lionheart.get('facility-booking/list/payments/' + payment_id, { params: { facility_id: facility_id, timezone: moment.tz.guess() } }).then((success) => success.data.data);
            // this.$data.facility_booking = data

            this.$bvModal.show('show-modal')
        },
        async handle_custom_date() {
            // this.filter.date_from = this.custom_filter.date_from;
            // this.filter.date_to = this.custom_filter.date_to;
            // this.$bvModal.hide("date-filter-modal");
            // this.custom_filter.selected_date_option_key = this.custom_filter.is_custom_selected_date_option_key;
            // this.config.is_date_option_selected = true;
            // await this.store_filter();
            // await this.list({ ...this.filter, page: 1 });
        },
    },
    mixins: [formatters],
}